import React, {useContext, useEffect, useState} from 'react'
import operatorContext from '../../context/operator/operatorContext'

const ViewOperatorSkills = () => {

    const OperatorContext = useContext(operatorContext);

    const { operator, getOperatorSkills } = OperatorContext;

    const { operatorSkills } = operator
    const [operator_skill_gotten, setOperator_skill_gotten] = useState(null);

    useEffect(() => {

        if (operator_skill_gotten === null) {
            getOperatorSkills().then(skill_items => {
                setOperator_skill_gotten(skill_items.length)
            })
        }
    })

    return (
        <div className="col-md-12 col-lg-12 col-xl-4 col-sm-4 ">
            <h3 className="mb-4 text-center">Your Skills</h3>
            <div className="card bg-color-3">
                <div className="card-body">
                    <div className="media align-items-center">
                        <div className="media-body text-white">
                            {
                                operatorSkills.length > 0 ?
                                    <ul>
                                        {operatorSkills.map(os => {
                                            return <li key={os.id}>{os.skill.name}</li>
                                        })}
                                    </ul> :
                                <h5>No skills available...</h5>
                            }
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ViewOperatorSkills
